module.exports = __webpack_public_path__ + "static/media/dino.ca60c323.png";